import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConnectionService } from 'src/app/connection.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.css']
})
export class MainLayoutComponent implements OnInit {

  searchobj: any = {
    searchAddress: ''
  }
  openCard: boolean = false; 
  searchType: string;
  searchData: Object;
  accounts: any;

  constructor( private router: Router,private conn: ConnectionService,) { }

  ngOnInit() {
  }

  searchDetails(event:any,type: any, search: any) {
    if(event.keyCode == 13){
      if(type == 'address'){
        this.router.navigate(['/account-details/',search])
      }
      else if ( type == 'transHash' || type == 'blockNumber') {
        this.router.navigate(['/tag/', type, search])
      }
      else if (type == 'token' || search == 'ABC') {
        this.router.navigate(['/token-tracker'])
      }
      else if(type == undefined && search.length == 34 ) {
        this.router.navigate(['/account-details', search])
      }
      else 
      {
        this.router.navigate(['/tag/', 'allFilters', search])
      }
    } 
  }

  getSearchsuggestion(event: any, search: any) {
    if (search != '') {
      this.openCard = true;
      if (search.length == 34) {
        this.searchType = 'Accounts'
        this.conn.getUsers(`users/suggestions`, 'searchquery', search).subscribe((res) => {
          this.accounts = res[0]
          if (event.keyCode == 13) {
            this.openCard = false
            this.searchobj.searchAddress = ''
          }
        })
      }
      else {
        this.searchType = 'Tokens'
        this.conn.getUsers(`users/suggestions`, 'searchquery', search).subscribe((res) => {
          this.searchData = res
          if (event.keyCode == 13) {
            this.openCard = false
            this.searchobj.searchAddress = ''
          }
        })
      }
    }
    else {
      this.openCard = false
    }
  }
}
